<script setup lang="ts">
import { ref, nextTick } from 'vue';
import type { SelectValue, DefaultOptionType } from 'ant-design-vue/es/select'


const siteOptions: DefaultOptionType[]  = [
  {id : 1, label : '울산시청', value : 'https://www.ulsan.go.kr/'},
  {id : 2, label : '울산테크노파크', value : 'https://www.utp.or.kr/'},
  {id : 3, label : '울산정보산업진흥원', value : 'https://uipa.or.kr/'},
  {id : 4, label : '울산창조경제혁신센터', value : 'https://ccei.creativekorea.or.kr/ulsan/'},
  {id : 5, label : '울산상공회의소', value : 'https://ulsan.korcham.net/'},
  {id : 6, label : '울산경제일자리진흥원', value : 'https://ubpi.or.kr/'},
  {id : 7, label : '울산연구원', value : 'https://www.uri.re.kr/'},
  {id : 8, label : '울산테크노파크(UBIZ)', value : 'https://platform.utp.or.kr/'},
];

const selected = ref<string | undefined>(undefined);

const onChange = (value: SelectValue, _option: DefaultOptionType | DefaultOptionType[]) => {
  const url =
      typeof value === 'string'
          ? value
          : Array.isArray(value)
              ? (typeof value[0] === 'string' ? value[0] : undefined)
              : (value as any)?.value

  if (process.client && typeof url === 'string' && url) {
    window.open(url, '_blank', 'noopener')
  }
  nextTick(() => (selected.value = undefined))
}
</script>

<template>
    <a-select
        class="footer-other-select"
        v-model:value="selected"
        :options="siteOptions"
        @change="onChange"
        placeholder="관련기관 사이트"
        :dropdown-match-select-width="false"
    >
      <template #suffixIcon>
        <img src="~/assets/img/pc/main/footer-plus.svg" alt="select-arrow" />
      </template>

    </a-select>
</template>

<style scoped lang="scss">
@use 'select.scss';
</style>